import { render } from "./AchievementsTab.vue?vue&type=template&id=058082b5&scoped=true"
import script from "./AchievementsTab.vue?vue&type=script&lang=js"
export * from "./AchievementsTab.vue?vue&type=script&lang=js"

import "./AchievementsTab.vue?vue&type=style&index=0&id=058082b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058082b5"]])

export default __exports__